import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Shield, Trophy, Star, Eye, Crown, Utensils, ShoppingBag, Mountain, Waves, GraduationCap, Users } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { ListingsComingSoon } from '../components/ListingsComingSoon';
const placeholderListings = [{
  id: 1,
  price: '$3,250,000',
  address: '552 Dragon Peak Dr',
  area: 'MacDonald Highlands',
  beds: 5,
  baths: 6,
  sqft: '5,800',
  image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 2,
  price: '$1,850,000',
  address: '1489 Foothills Village Dr',
  area: 'MacDonald Highlands',
  beds: 4,
  baths: 4.5,
  sqft: '4,200',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
}, {
  id: 3,
  price: '$5,900,000',
  address: '23 Skyline Summit',
  area: 'MacDonald Highlands',
  beds: 6,
  baths: 8,
  sqft: '8,500',
  image: 'https://images.unsplash.com/photo-1613490908571-9ce224083933?q=80&w=2838&auto=format&fit=crop'
}];
export function MacDonaldHighlandsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white" data-id="element-442">
      <section className="relative h-[70vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-443">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1613490908571-9ce224083933?q=80&w=2838&auto=format&fit=crop")'
      }} data-id="element-444">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-445"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80" data-id="element-446"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-447">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-448">
            <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-449">
              Community Spotlight
            </span>
            <h1 className="text-5xl md:text-7xl text-white font-serif mb-6 leading-tight" data-id="element-450">
              MacDonald Highlands
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto" data-id="element-451">
              Ultra-luxury gated enclave in Henderson with the most breathtaking
              panoramic views in all of Las Vegas.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-452">
        <div className="max-w-7xl mx-auto" data-id="element-453">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-454">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-455">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-456">
                The Crown Jewel of{' '}
                <span className="italic text-gold" data-id="element-457">Henderson</span>
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-458">
                <p data-id="element-459">
                  MacDonald Highlands is the most exclusive residential
                  community in the Las Vegas Valley. Perched high in the
                  McCullough Range above Henderson, this guard-gated enclave
                  offers jaw-dropping 360-degree panoramic views of the entire
                  Las Vegas Strip, the surrounding mountains, and Lake Mead in
                  the distance.
                </p>
                <p data-id="element-460">
                  Developed by MacDonald Properties, the community features
                  custom homesites ranging from half an acre to over two acres,
                  with homes designed by the region's most acclaimed architects.
                  Prices range from $1.5M to over $15M for the most spectacular
                  estates.
                </p>
                <p data-id="element-461">
                  At the heart of the community is DragonRidge Country Club, one
                  of the most prestigious private clubs in Nevada, offering
                  world-class golf, dining, fitness, and social events in an
                  unmatched setting.
                </p>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-6" data-id="element-462">
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-463">
                <Crown className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-464" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-465">
                  Ultra
                </h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-466">
                  Luxury
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-467">
                <Eye className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-468" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-469">360°</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-470">
                  Strip Views
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-471">
                <Shield className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-472" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-473">24/7</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-474">
                  Guard Gated
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-475">
                <Trophy className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-476" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-477">18</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-478">
                  Hole Golf
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* DragonRidge */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-479">
        <div className="max-w-7xl mx-auto" data-id="element-480">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-481">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-2 lg:order-1" data-id="element-482">
              <div className="relative h-[500px]" data-id="element-483">
                <img src="https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=2940&auto=format&fit=crop" alt="DragonRidge Golf" className="w-full h-full object-cover" data-id="element-484" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-485"></div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-1 lg:order-2" data-id="element-486">
              <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-487">
                Private Club
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-488">
                DragonRidge Country Club
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-489">
                <p data-id="element-490">
                  DragonRidge Country Club is the crown jewel of MacDonald
                  Highlands. The 18-hole championship course, designed by Jay
                  Morrish and David Druzisky, winds dramatically through the
                  mountains with elevation changes of over 300 feet — creating
                  one of the most visually stunning golf experiences in the
                  world.
                </p>
                <p data-id="element-491">
                  The 47,000 square foot clubhouse features fine dining, a
                  full-service spa, resort-style pool, tennis courts, and a
                  state-of-the-art fitness center. Members enjoy an intimate,
                  exclusive atmosphere with only 400 memberships available.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* The Views */}
      <section className="py-24 px-6 bg-white" data-id="element-492">
        <div className="max-w-7xl mx-auto" data-id="element-493">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-494">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-495">
              Unmatched Vistas
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-496">
              The Views Define the Lifestyle
            </h2>
            <p className="text-charcoal-light font-light max-w-3xl mx-auto mt-4 text-lg" data-id="element-497">
              What truly sets MacDonald Highlands apart is the view. From nearly
              every home, you can see the glittering Las Vegas Strip stretching
              across the valley floor, framed by the Spring Mountains to the
              west and Lake Mead to the east. At night, the city transforms into
              a sea of lights that rivals any view in the world.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-498">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group" data-id="element-499">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-500">
                <img src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2940&auto=format&fit=crop" alt="Luxury Estate" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-501" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-502">
                Custom Estates
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-503">
                Architecturally stunning homes designed by the valley's top
                architects, featuring infinity pools, home theaters, and wine
                cellars.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group" data-id="element-504">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-505">
                <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=2874&auto=format&fit=crop" alt="Interior" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-506" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-507">
                Designer Interiors
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-508">
                Homes feature the finest finishes — imported stone, custom
                millwork, smart home technology, and floor-to-ceiling glass to
                capture the views.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="group" data-id="element-509">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-510">
                <img src="https://images.unsplash.com/photo-1540539234-c14a20fb7c7b?q=80&w=2940&auto=format&fit=crop" alt="Spa" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-511" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-512">
                Private Amenities
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-513">
                Many estates include private spas, putting greens, outdoor
                kitchens, and resort-style backyards with Strip views.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Location & Nearby */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-514">
        <div className="max-w-7xl mx-auto" data-id="element-515">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-516">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-8" data-id="element-517">
              <div data-id="element-518">
                <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-519">
                  Prime Location
                </span>
                <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-520">
                  Minutes From Everything
                </h2>
                <p className="text-charcoal-light font-light leading-relaxed text-lg" data-id="element-521">
                  Despite its secluded, mountaintop feel, MacDonald Highlands is
                  just minutes from Henderson's best amenities and a short drive
                  to the Las Vegas Strip.
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-522">
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-523">
                  <Utensils className="w-6 h-6 text-gold mb-3" data-id="element-524" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-525">
                    Fine Dining
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-526">
                    Minutes from Henderson's top restaurants including Todd's
                    Unique Dining, Bottiglia, and the M Resort dining
                    collection.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-527">
                  <ShoppingBag className="w-6 h-6 text-gold mb-3" data-id="element-528" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-529">
                    The District
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-530">
                    Green Valley's premier open-air shopping and dining
                    destination is just a 10-minute drive down the hill.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-531">
                  <Waves className="w-6 h-6 text-gold mb-3" data-id="element-532" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-533">
                    Lake Mead
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-534">
                    Just 20 minutes to Lake Mead National Recreation Area for
                    boating, fishing, and stunning desert waterscapes.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-535">
                  <Mountain className="w-6 h-6 text-gold mb-3" data-id="element-536" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-537">
                    Sloan Canyon
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-538">
                    Nearby national conservation area with ancient petroglyphs
                    and world-class desert hiking trails.
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-539">
              <div className="relative h-[600px]" data-id="element-540">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2940&auto=format&fit=crop" alt="Mountain Views Henderson" className="w-full h-full object-cover" data-id="element-541" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-542"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Exclusive Living */}
      <section className="py-24 px-6 bg-white" data-id="element-543">
        <div className="max-w-4xl mx-auto text-center" data-id="element-544">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-545">
            <Users className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-546" />
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-547">
              An Elite Address
            </span>
            <h2 className="text-4xl font-serif text-charcoal mb-6" data-id="element-548">
              Who Lives in MacDonald Highlands
            </h2>
            <p className="text-charcoal-light font-light leading-relaxed text-lg mb-8" data-id="element-549">
              MacDonald Highlands attracts a discerning clientele of successful
              entrepreneurs, executives, professional athletes, and entertainers
              who value privacy, exclusivity, and the finest things in life. The
              community's limited number of homesites ensures an intimate
              atmosphere where neighbors become friends.
            </p>
            <p className="text-charcoal-light font-light leading-relaxed text-lg mb-12" data-id="element-550">
              With 24/7 guard-gated security, private roads, and a community
              designed for those who have achieved the highest levels of
              success, MacDonald Highlands isn't just a place to live — it's a
              statement. The community regularly hosts exclusive social events
              at DragonRidge, fostering a tight-knit network of like-minded
              residents.
            </p>
            <div className="flex flex-wrap justify-center gap-8" data-id="element-551">
              <div className="flex items-center gap-2 text-charcoal" data-id="element-552">
                <Star className="w-5 h-5 text-gold" data-id="element-553" />
                <span className="font-serif" data-id="element-554">Entrepreneurs & Executives</span>
              </div>
              <div className="flex items-center gap-2 text-charcoal" data-id="element-555">
                <Star className="w-5 h-5 text-gold" data-id="element-556" />
                <span className="font-serif" data-id="element-557">Professional Athletes</span>
              </div>
              <div className="flex items-center gap-2 text-charcoal" data-id="element-558">
                <Star className="w-5 h-5 text-gold" data-id="element-559" />
                <span className="font-serif" data-id="element-560">Entertainment Industry</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Listings */}
      <ListingsComingSoon area="MacDonald Highlands" data-id="element-561" />

      <ContactCTA data-id="element-562" />
    </main>;
}